import RotatingProduct from "../modules/ddd";

const containerEl = document.querySelector('.js-ddd');
if (containerEl) {
  const loaderEl = containerEl.querySelector('.js-ddd-loader');
  const imgEls = containerEl.querySelectorAll('.js-ddd-img');
  
  if (imgEls) {
    // console.log('creating observer for ddd');
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          // console.log('ddd observer entry visible');
          new RotatingProduct(containerEl, imgEls, loaderEl);
          observer.unobserve(entry.target);
        }
      });
    });
    observer.observe(containerEl);
  }
}